<template>
  <div class="bg-white m-3 rounded-md pb-5">
    <ve-table
        :columns="columns"
        :table-data="employeeData"
    />
  </div>
</template>
<script>
 export default {
   name:"employeeMonthlyReviews",
   data(){
    return {
      employeeData:[],
      columns: [
        {
          field: "Employee No.", key: "a", title: "Employee No.", align: "left",
          renderBodyCell: ({ row }) => (
              <p class="capitalize">{row.EmployeeNo}</p>
          ),
        },
        {
          field: "Employee Name",
          key: "b",
          title: "Employee Name",
          align: "left",
          renderBodyCell: ({ row }) => (
              <p class="capitalize">{row.EmployeeName}</p>
          ),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
              <span class="underline text-blue-800 cursor-pointer" onClick={() => this.fetchEmployeeObjectives(row)}>View</span>

          ),
        },
      ],
    }
   }
 }
</script>